<template>
  <div class="version-assets-table-container">
    <b-table
      :items="t_portfolio"
      :fields="fields"
      thead-class="hidden_header"
      class="version-assets-table"
      :perPage="perPage"
      :page="currentPage"
    />
    <div class="table-footer-vals">
      <div class="footer-row">
        <span class="row-title">{{
          $t("portfolioManager.portfolioLifecycle.openPositions")
        }}</span>
        <span class="row-value body-bold">{{ `${openPositionsValue}%` }}</span>
      </div>
      <div class="footer-row">
        <span class="row-title">{{
          $t("portfolioManager.portfolioLifecycle.cashReserve")
        }}</span>
        <span class="row-value body-bold">{{ `$${cashReserve}` }}</span>
      </div>
    </div>
    <table-footer
      :perPage="perPage"
      :page="currentPage"
      :totalRows="t_portfolio.length"
      @pageChange="(num) => (perPage = num)"
      v-if="t_portfolio.length > this.perPage"
    />
  </div>
</template>

<script>
import TableFooter from "./tableComponents/TableFooter.vue";
import { mapPortfolioToArray } from "../../utils/helper";

export default {
  components: { TableFooter },
  name: "version-assets-table",
  props: {
    portfolio: Object,
    cashReserve: Number,
  },
  data() {
    return {
      fields: [
        {
          key: "ticker",
          tdClass: "body-bold",
        },
        {
          key: "weight",
          formatter: (val) => `${(val * 100).toFixed(2)} %`,
          tdClass: "align-right",
        },
      ],
      perPage: 5,
      currentPage: 1,
    };
  },
  computed: {
    t_portfolio() {
      return mapPortfolioToArray(this.portfolio);
    },
    openPositionsValue() {
      return this.t_portfolio.every((item) => item.weight)
        ? this.t_portfolio.reduce((acc, curr) => acc + curr.weight, 0) * 100
        : 0;
    },
  },
};
</script>

<style lang="scss">
.table-footer-vals {
  padding: 0.75rem;
  .footer-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: toRem(15);
    .row-title {
      text-transform: uppercase;
      color: black;
    }
  }
}
</style>